import { DateRangeInput3 } from '@blueprintjs/datetime2';
import BOSSelect from 'Components/Generic/BOSSelect';
import { parse } from 'date-fns';
import { CURRENT_FISCAL_YEAR_DR, DATE_RANGES } from 'Pages/Reports/Enum';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  areRangesEqual,
  DATE_FORMAT,
  defaultMaxDate,
  formatDate,
} from 'Util/dateUtil';
import styles from './BOSDates.module.css';

const customDateRangeObject = DATE_RANGES.find((dro) => dro.id === 'CUSTOM');

const BOSDateInput = ({ defaultValue, defaultRange, onChange = () => {} }) => {
  const [selectedDateRangeObject, setSelectedDateRangeObject] = useState(
    defaultValue || CURRENT_FISCAL_YEAR_DR,
  );
  const [selectedRange, setSelectedRange] = useState();

  useEffect(() => {
    selectedDateRangeObject?.dateRange &&
      setSelectedRange(selectedDateRangeObject.dateRange);
  }, [selectedDateRangeObject]);

  useEffect(() => {
    defaultRange && setRange(defaultRange);
  }, []);

  useEffect(() => {
    onChange(selectedRange);
  }, [selectedRange]);

  const setRange = (selectedRange) => {
    setSelectedRange(selectedRange);
    if (!areRangesEqual(selectedDateRangeObject.dateRange, selectedRange)) {
      let matchingRangeObject = DATE_RANGES.find((dro) =>
        areRangesEqual(dro.dateRange, selectedRange),
      );
      let objectToSelect = matchingRangeObject || customDateRangeObject;
      if (selectedDateRangeObject !== objectToSelect) {
        setSelectedDateRangeObject(objectToSelect);
      }
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <BOSSelect
        outerClassName={styles.range_dropdown_div}
        inputClassName={styles.range_dropdown}
        listData={DATE_RANGES}
        labelField={'label'}
        defaultSelectedId={selectedDateRangeObject.id}
        onItemSelect={(dro) => setSelectedDateRangeObject(dro)}
        floatSelected={false}
      />
      <DateRangeInput3
        className={styles.range_input}
        value={selectedRange}
        onChange={setRange}
        formatDate={formatDate}
        parseDate={(str) => parse(str, DATE_FORMAT, new Date())}
        popoverProps={{ minimal: true, placement: 'bottom-start' }}
        shortcuts={false}
        maxDate={defaultMaxDate}
        closeOnSelection
      />
    </div>
  );
};

BOSDateInput.propTypes = {
  defaultValue: PropTypes.object,
  defaultRange: PropTypes.array,
  onChange: PropTypes.func,
};

export default BOSDateInput;
